﻿import findClosestScrollContainer from "./findClosestScrollContainer.js";

export default (id, scrollVerticallyOnly) => {
  console.log(`[ScrollToId] Attempting to scroll to element with ID: ${id}`);

  const element = document.getElementById(id);
  if (!element) {
    console.warn(`[ScrollToId] Element with ID: ${id} not found.`);
    return false;
  }

  console.log(`[ScrollToId] Found element with ID: ${id}. Initiating scroll.`);
  element.scrollIntoView({behavior: "instant", block: "start", inline: "start"});

  const scrollContainer = findClosestScrollContainer(element);
  if (scrollContainer) {
    console.log(`[ScrollToId] Found closest scroll container. Adjusting scroll position to account for toolbars.`);
    scrollContainer.scrollBy({top: -200, behavior: "instant"});

    if (scrollVerticallyOnly) {
      console.log(`[ScrollToId] Scroll set to vertical-only mode. Setting horizontal scroll to 0.`);
      scrollContainer.scrollTo({left: 0});
    }
  } else {
    console.warn(`[ScrollToId] No scroll container found for element with ID: ${id}. Adjusting scroll position to account for toolbars.`);
    window.scrollBy({top: -200, behavior: "instant"});
  }

  return true;
};
